import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ animation = "border", size = "md", message = "Loading..." }) => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
            <Spinner animation={animation} role="status" size={size} className="me-2">
                <span className="visually-hidden">{message}</span>
            </Spinner>
             {message && <span>{message}</span>}
        </div>
    );
};

export default LoadingSpinner;